import { Icon, IconNames } from '@triumph/design-system';
import {
    FILTER_CATEGORIES,
    FILTER_CATEGORY_LABELS,
    getFilterDisabledInfo,
} from './filterRegistry';
import {
    PickerCategoryHeader,
    PickerRowDescription,
    PickerRowLabel,
    PickerRowTitle,
    PickerSearchInput,
} from './FilterDrawer.styles';
import { FilterDefinition } from './types';

export interface FilterCategorySearchProps {
    query: string;
    onQueryChange: (query: string) => void;
}

export function FilterCategorySearch({ query, onQueryChange }: FilterCategorySearchProps) {
    return (
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 8 }}>
            <Icon
                name={IconNames.Interface_Search}
                size={16}
                id="filter-picker-search-icon"
            />
            <PickerSearchInput
                type="search"
                data-testid="filter-picker-search"
                placeholder="Search filters..."
                value={query}
                onChange={(e) => onQueryChange(e.target.value)}
            />
        </div>
    );
}

export interface FilterCategoryPickerProps {
    registry: FilterDefinition[];
    picked: Set<string>;
    onToggle: (id: string) => void;
    query: string;
}

export function FilterCategoryPicker({ registry, picked, onToggle, query }: FilterCategoryPickerProps) {
    const matches = (f: FilterDefinition) =>
        !query || `${f.label} ${f.description}`.toLowerCase().includes(query.toLowerCase());

    return (
        <div>
            {FILTER_CATEGORIES.map((cat) => {
                const rows = registry.filter((f) => f.category === cat && matches(f));
                if (rows.length === 0) return null;
                return (
                    <div key={cat}>
                        <PickerCategoryHeader>{FILTER_CATEGORY_LABELS[cat]}</PickerCategoryHeader>
                        {rows.map((f) => {
                            const { disabled, reason } = getFilterDisabledInfo(f, picked);
                            return (
                                <PickerRowLabel
                                    key={f.id}
                                    data-testid={`filter-picker-row-${f.id}`}
                                    isSelected={picked.has(f.id)}
                                    isDisabled={disabled}
                                    title={reason ?? undefined}
                                >
                                    <input
                                        type="checkbox"
                                        checked={picked.has(f.id)}
                                        disabled={disabled}
                                        onChange={() => {
                                            if (!disabled) onToggle(f.id);
                                        }}
                                    />
                                    <div>
                                        <PickerRowTitle>{f.label}</PickerRowTitle>
                                        <PickerRowDescription>
                                            {disabled && reason ? reason : f.description}
                                        </PickerRowDescription>
                                    </div>
                                </PickerRowLabel>
                            );
                        })}
                    </div>
                );
            })}
        </div>
    );
}
